export default __webpack_public_path__ + "static/media/arrow_top_chevron_icon.6ccf0bfe.svg";